import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../infra/base-service';
import {ChaveValor, ChaveValorUF} from '../interfaces/segmentacao/chave-valor.interface';
import {FiltroParamRequest, FiltroSegmentacao} from '../interfaces/segmentacao/filtro-segmentacao.interface';
import { DadosGrafico } from '../interfaces/segmentacao/dados-grafico.interface';
import { ApiResponse } from '../interfaces/api-response.interface';
import { ResponseRetornoSegmentacao, RetornoSegmentacao } from '../interfaces/segmentacao/retorno-segmentacao.interface';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class SegmentacaoService extends BaseService {

  constructor(http: HttpClient, toastr: ToastrService) {
    super(http, toastr);
  }

  private abrangenciaSelecionada: string[] = ['FEDERAL', 'ESTADUAL', 'MUNICIPAL'];

  getAbrangenciaSelecionada(): string[] {
    return this.abrangenciaSelecionada;
  }

  setAbrangenciaSelecionada(abrangencia: string[]) {
    this.abrangenciaSelecionada = abrangencia;
  }
  
  listarFiltro(params: FiltroParamRequest): Promise<ChaveValor[]>  {
    return this.get<ChaveValor[]>('dados/listar-filtro', params);
  }

  buscarFiltro(params: FiltroParamRequest): Promise<ChaveValor[]> {
    return this.get<ChaveValor[]>('dados/buscar-filtro', params);
  }

  buscarFiltroCidades(params: FiltroParamRequest): Promise<ChaveValorUF[]> {
    return this.get<ChaveValorUF[]>('dados/buscar-filtro', params);
  }

  buscarSegmentacao(params: FiltroSegmentacao): Promise<ResponseRetornoSegmentacao> {
    return this.post<ResponseRetornoSegmentacao>('segmentacao/filtrar', params);
  }  
}


